import {uniquenessFilter} from 'web-app/util/array';
import {isNonEmpty} from 'web-app/util/non-empty-array';

import type * as Types from './types';

export const bodyMapPointsToTrackingData = (bodyMapPoints: Types.ApiRequestBodyMapPoint[]) => ({
    hasBodyMaps: isNonEmpty(bodyMapPoints),
    bodyMapPointCount: bodyMapPoints.length,
    bodyMapCount: bodyMapPoints.filter(uniquenessFilter(bodyMapPoint => bodyMapPoint.fileId)).length,
    bodyMapImages: bodyMapPoints
        .filter(uniquenessFilter(bodyMapPoint => bodyMapPoint.imageLabel))
        .map(bodyMapPoint => bodyMapPoint.imageLabel),
});
